import React from "react";
import FaqBanner from '../../assets/images/resources/faq-banner-img.jpg'

function PackageBanner() {
  return (
    <div>
      <section className="pachage-banner">
        <div className="container">
          <div
            className="pachage-banner-img wow fadeInUp animated"
            data-wow-duration="1500ms"
            data-wow-delay="300ms"
          >
            <img
              src={FaqBanner}
              alt="faq-banner-img"
            />
          </div>
        </div>
      </section>
    </div>
  );
}

export default PackageBanner;
